
import { defineComponent } from 'vue';
import { mapGetters } from 'src/store';

export default defineComponent({
  name: 'UndefinedServerErrorModal',
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  setup() {
    return {
      ...mapGetters('app', ['isUndefinedServerError']),
      reload() {
        window.location.reload();
      },
    };
  },
});
